import { BaseExportModal, ExportModalProps } from './ExportModal'
import { UNIVERSITY_COLUMNS } from 'components/DataExpansionComponents/Universities/universityColumnsInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startUniversitiesExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function UniversityExportModal(props: ExportModalProps) {
  const universityColumnHelper = createExportColumnHelper({
    columns: UNIVERSITY_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        universityColumnHelper.retrieveColumn('institution_name'),
        universityColumnHelper.retrieveColumn('address'),
        universityColumnHelper.retrieveColumn('city'),
        universityColumnHelper.retrieveColumn('state_abbr'),
        universityColumnHelper.retrieveColumn('zipcode'),
        universityColumnHelper.retrieveColumn('domain'),
        universityColumnHelper.retrieveColumn(
          'carnegie_classification_2021_size_setting_size'
        ),
        universityColumnHelper.retrieveColumn(
          'carnegie_classification_2021_size_setting_year'
        ),
        universityColumnHelper.retrieveColumn(
          'carnegie_classification_2021_size_setting_student_composition'
        ),
        universityColumnHelper.retrieveColumn('total_enrollment'),
        universityColumnHelper.retrieveColumn('total_men_enrollment'),
        universityColumnHelper.retrieveColumn('total_women_enrollment'),
        universityColumnHelper.retrieveColumn('dormitory_capacity'),
        universityColumnHelper.retrieveColumn('google_place_url'),
      ],
    },
    {
      title: 'Dining Services',
      elements: [
        universityColumnHelper.retrieveColumn('meal_plan_provided'),
        universityColumnHelper.retrieveColumn('food_management_company'),
        universityColumnHelper.retrieveColumn('food_management_company_parent'),
        universityColumnHelper.retrieveColumn('estimated_meals_per_day'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Universities...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startUniversitiesExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Universities',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Universities Download"
      subTitle="Download up to 10,000 universities at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Universities"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
